//import Navbar from "./scenes/Navbar";
//import Landing from "./scenes/Landing";
import DotGroup from "./scenes/DotGroup";
import MySkills from "./scenes/MySkills";
import LineGradient from "./components/LineGradient";
import Projects from "./scenes/Projects";
import Contact from "./scenes/Contact";
import Footer from "./scenes/Footer";
import useMediaQuery from "./hooks/useMediaQuery";
import Testimonials from "./scenes/Testimonials";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";

import MainMint from './MainMint';
import NavBarV1 from './NavBarV1';
import NavBar from './NavBar';
import LandingV2 from './LandingV2';
import Landing from './Landing';
import Rupture from './Rupture';
import RoadMap from './RoadMap';

import LoginForm from './LoginForm';

import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';


import {Box, Button, Flex, Image, Link, Spacer, Center} from '@chakra-ui/react';

function App() {
  const [selectedPage, setSelectedPage] = useState("mint");
  const [isTopOfPage, setIsTopOfPage] = useState(true);
  const isDesktop = useMediaQuery("(min-width: 1060px)");

  const [accounts, setAccounts] = useState([]);

  //const navigate = useNavigate();

  const navigateToSubdomain = (subdomain) => {
    window.location.href = `https://kascade-bucket.s3.eu-north-1.amazonaws.com/index.html`;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsTopOfPage(true);
        setSelectedPage("mint");
      }
      //if (window.scrollY !== 0) setIsTopOfPage(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

/////NEW
  const [formData, setFormData] = useState({
    username: "" , 
    password: "",
    errors: {},
    loading: false,
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };
  
  const validateForm = () => {
    const errors = {};

    // Check if username is empty
    /*
    if (!formData.username) {
      errors.username = "Username is required";
    }
    */
    // Check if password is empty

    /*
    if (!formData.password) {
      errors.password = "Password is required";
    }
    */

    if (formData.password != "edtrg"){
      errors.password = "Incorrect";
    }
    
    else {
      // Redirect to the desired URL
      navigateToSubdomain('subdomain');
      //navigate('https://kascade-bucket.s3.eu-north-1.amazonaws.com/index.html');
      
    }
      
      setFormData((prevState) => ({ ...prevState, errors }));
    // Return true if there are no errors
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (event) => {

    event.preventDefault();

    setFormData({
      ...formData,
      loading: true,
    }); 

    // Simulate form submission delay
    setTimeout(() => {
      console.log(formData);
      setFormData({
        ...formData,
        loading: false,
      });
    }, 2000);

    if (validateForm()) {
      // Form is valid, submit data

      console.log(formData);

    } else {
      // Form is invalid, do nothing
    }

  };
  


  return (
    
    <div >  

      <BrowserRouter>
        <Routes>
        
        </Routes>
      </BrowserRouter>


      <NavBar accounts={accounts} 
                setAccounts={setAccounts}
                isTopOfPage={isTopOfPage}
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage} />
      
        {isDesktop }
        <motion.div
          margin="0 0 0 0"
          amount="all"
          onViewportEnter={() => setSelectedPage("mint")} >
    
          <Landing setSelectedPage={setSelectedPage} />
        
        </motion.div>
      
      <LineGradient />

      
        <form onSubmit={handleSubmit}>
        <label>

          {formData.errors.username && (
            <p style={{ color: "red" }}>{formData.errors.username}</p>
          )}
        </label>
        <label>
          ~$
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
          />
          {formData.errors.password && (
            <p style={{ color: "red" }}>{formData.errors.password}</p>
          )}
        </label>
        <input type="submit" value="" disabled={formData.loading} />
          {formData.loading && (
            <div style={{ marginTop: 5, fontWeight: "bold" }}>Loading...</div>
          )}
      </form>         
    </div>

  );
}

export default App;


//<div className="w-5/6 mx-auto">
//<motion.div
//  margin="0 0 -200px 0"
//  amount="all"
//  onViewportEnter={() => setSelectedPage("roadmap")}
//>
//  <RoadMap />
//</motion.div>
//</div>

/*

<div className="w-5/6 mx-auto md:h-full ">
        <motion.div
          margin="0 0 -200px 0"
          amount="all"
          onViewportEnter={() => setSelectedPage("rupture")}
        >
          <Rupture />
        </motion.div>
      </div>
      <LineGradient />
      


      <LineGradient />
      <div className="w-5/6 mx-auto md:h-full">
        <motion.div
          margin="0 0 -200px 0"
          amount="all"
          onViewportEnter={() => setSelectedPage("contact")}
        >
          <Contact />
        </motion.div>
      </div>
    
      <Footer />


*/
